export default __webpack_public_path__ + "static/media/Facebook-icon.83f897bb.webp";